import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Modal from "react-modal";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";

const CustomerListview = (props) => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [custAddress, setCustAddress] = useState();
  const [personDetails, setPersonDetails] = useState();
  const [bankDetails, setBankDetails] = useState();

  const openModal = (data) => {
    setSelectedData(data);
    setBankDetails(data & data.bankDetails);

    setCustAddress(data && data.customerAddressDetails);
    setPersonDetails(data && data.contactPersonDetails);

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const { addForm } = props;

  const [data, setData] = useState([]);

  const { sendRequest: getCustomer } = useHttp();

  useEffect(() => {
    getCustomer(
      {
        url: `/api/customer/?orgId=${localStorage.getItem("orgId")}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          //console.log(data);
          setData(res);
        }
      }
    );
  }, [getCustomer]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteCustomer } = useHttp();

  const handleDelete = (e, customerId) => {
    e.preventDefault();

    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Customer detail?",
      onOk() {
        const data = {
          customerId: customerId,
        };
        // //console.log(data);

        deleteCustomer(
          {
            url: "/api/customer/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            //console.log(data);
            toast.success(data);
          }
        );
      },
      onCancel() {
        // Do nothing if the user cancels the delete action.
      },
    });
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Customers</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Customer
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center table-sm">
                      <thead>
                        <tr>
                          <th>Profile</th>
                          <th>Customer No</th>
                          <th>Customer Name</th>
                          <th>Contact Person Name</th>
                          <th>field Executive Name</th>
                          <th>Payment Terms in Days</th>
                          <th>View</th>
                          <th>Edit</th>
                          <th>Delete</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((x, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  {" "}
                                  <img
                                    src={`${process.env.REACT_APP_FILE_URL}${x.fileProfile}`}
                                    className="user-image img-circle"
                                    width="60"
                                    height="60"
                                    alt="User Image"
                                  />
                                </td>
                                <td>{x.customerCode}</td>
                                <td>{x.name}</td>
                                <td>
                                  {x.contactPersonDetails[0] &&
                                    x.contactPersonDetails[0].name}
                                </td>
                                <td>{x.fieldExecutiveName}</td>

                                <td>{x.paymentTermsInDays}</td>
                                
                                <td>
                                  {" "}
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(x);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={(e) =>
                                      handleDelete(e, x.customerId)
                                    }
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Customers Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Customer No: {selectedData.customerCode}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Customer Name: {selectedData.name}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Email : {selectedData.emailId}</p>

              <p className="col-md-6">
                Work Contact Number: {selectedData.workContactNumber}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Status : {selectedData.status == 1 ? "Active" : "Deactive"}
              </p>

              <p className="col-md-6">
                payment Terms(In Days): {selectedData.paymentTermsInDays}
              </p>
            </div>
            <h5 className="card-title">Customer Address Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Address Type</th>
                  <th>Address(landmark)</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip Code</th>
                  <th>Country</th>
                </tr>
              </thead>
              <tbody>
                {custAddress &&
                  custAddress.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.addressType}</td>
                        <td>{itm.address}</td>
                        <td>{itm.city}</td>
                        <td>{itm.state}</td>
                        <td>{itm.zipCode}</td>
                        <td>{itm.country}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <h5 className="card-title">Contact Person Details</h5>
            <table className="table tabel-sm text-center table-bordered table-responsive">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Contact Number</th>
                  <th>whatsapp Number</th>
                  <th>Email id</th>
                </tr>
              </thead>
              <tbody>
                {personDetails &&
                  personDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.name}</td>
                        <td>{itm.designation}</td>
                        <td>{itm.workContactNumber}</td>
                        <td>{itm.whatsappContactNumber}</td>
                        <td>{itm.emailId}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <h5 className="card-title">Customer Bank Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.bankDetails &&
                  selectedData.bankDetails.map((itm, i) => {
                    // //console.log(i);
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>
                        <td>{itm.ifscCode}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>{" "}
            {/**/}
          </div>
        )}
      </Modal>
    </>
  );
};

export default CustomerListview;
